import { ref } from 'vue';
// Cross-page handoff for "the user just changed a category — keep the row
// spinner on until the landing page's data reflects it". Set by
// TransactionDetailPage when a category change is applied; consumed by
// AccountPage / MoneyPage / SpendingAnalysisPage on mount via
// useTransactionUpdateHandoff.
export const pendingTransactionUpdateId = ref(null);
// One-shot flag set by TransactionDetailPage after a category write, signalling
// that the next spending-analysis fetch on whichever page mounts next should
// run with pollUntilChanged. Consumed atomically via consumePendingWriteRevalidate
// to avoid the read-then-clear footgun.
export const pendingWriteRevalidate = ref(false);
export function consumePendingWriteRevalidate() {
    const v = pendingWriteRevalidate.value;
    pendingWriteRevalidate.value = false;
    return v;
}
